import React, { useState } from 'react'
import Navbar from '../inc/Navbar'
import ScrollToTop from "react-scroll-to-top"
import { Link } from "react-router-dom";
import { Typewriter } from 'react-simple-typewriter'
import Callback from './Callback';
import ShiftingProcess from './ShiftingProcess';
import WorkProcess from './WorkProcess';
import helpdeskdetails from "../images/Helpdesk.jpg";
import Contactform from './Contactfrom';
import carmove from "../images/car- relocation new.jpg"
import Table from 'react-bootstrap/Table';

import ReactPlayer from 'react-player';


import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";






function CarRelocation() {


  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 3
  };

  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <br />
      <ScrollToTop smooth top="100" color="Gray" />
      <div className='packermovershoogle'>
        <div className="album py-0">

          <div className="container mt-3">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" href="#"><small>Home</small></Link></li>
                <li className="breadcrumb-item active" aria-current="page"><small>Car Relocation</small></li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div style={{
        backgroundImage: "url(" + "https://i.postimg.cc/1Rd0X05c/car-relocation-page.jpg" + ")",
        backgroundPosition: 'start',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      }}>

        <div className="album py-1">
          <div className="container">
            <div className="row">
              <div className="col-md-8 mt-3">
                             <button className='iba'>IBA Approved Packers and Movers</button>
                <h1 style={{ fontSize: "3rem", color: "white" }} className="card-text mb-4"> <b>Best Car Relocation Services in Kolkata</b></h1>

                <h6 style={{ color: "white" }} className="card-text mb-5">We use specially designed car carriers to ensure your vehicle’s safety during transit.</h6>
                <h1 className="card-text " style={{ margin: "auto 0", color: "white" }}> <b> Best Car Relocation Services in :  <span style={{ fontWeight: "bold", marginleft: '10px', color: "white" }}>
                  <Typewriter
                    loop
                    cursor
                    cursorStyle="_"
                    typeSpeed={100}
                    deleteSpeed={50}
                    delaySpeed={1000}
                    words={["New Town", "Hoogle", "Durgapur", "Bengalore", "Delhi", "Siliguri", "Murshidabad", "Bengalore", "Chennei", "Rajasthan"]}
                  />
                </span>
                </b></h1>
                <div className="indiastrustedwebsitedevelopment">
                  <h3 style={{ fontSize: "1rem", color: "white" }} className="card-text mb-8 mt-2"> <b>AT INDIA PACKERS MOVERS</b></h3>
                </div>
              </div>
              <div className="col-md-4 mt-3">
                <div className='packer_Rajarhatkolkata'>
                  <Contactform />
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <br />
        <br />










      </div>

      <div className='grey'>
        <br />
        <div className="album py-1">

          <div className="container">
            <center><h2 style={{ color: "#05438e" }}>How does it Work?</h2></center>
          </div>
        </div>
        <div className="album py-1">
          <div className="container">
            <div className="row">
              <div className="col-md-8 mt-3">
                <WorkProcess />
              </div>
              <div className="col-md-4 mt-4">
                <div className="card" >
                  <img src={helpdeskdetails} className="card-img-top" alt="helpdeskdetails" />
                  <div className="card-body">
                    <h5 style={{ color: "#05438e" }} className="card-title"><center>Helpful Details</center></h5>
                    <p className="card-text">Packing tips</p>

                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <br />
        <br />
        <div className="container">
          <div className='welcometext'>
            <h3 className="card-title mb-0"><b>Check Our Affordable Car Transportation Prices Below:

            </b></h3>
            <div className="col-md-10">
              <hr style={{ color: "#1D4D93" }} />
            </div>
          </div>
        </div>

        <div className="animat">
          <Slider {...settings}>

            <div>

              <div className="card mb-12">
                <Table striped bordered hover variant="light">
                  <thead>
                    <tr>
                      <th style={{ color: "#0439b5ff" }}>Service Type		</th>
                      <th style={{ color: "#0335aaff" }}>100 - 350 km</th>
                      <th style={{ color: "#032062" }}>350 - 750 km</th>
                      <th style={{ color: "#032062" }}>750 - 1200 km</th>
                      <th style={{ color: "#032062" }}>1200 - 1700 km</th>
                      <th style={{ color: "#032062" }}>1700 - 2300 km	</th>
                      <th style={{ color: "#032062" }}>2300 - 3000 km</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Hatchback Car Transportation Price	</td>
                      <td>Rs. 5500 - 11000	</td>
                      <td>	Rs. 7,500 - 14,000	</td>
                      <td>Rs. 9000 - 17000	</td>
                      <th>Rs. 11000 - 13000</th>
                      <th>Rs. 13000 - 23000</th>
                      <th>Rs. 15000 - 26000</th>


                    </tr>
                    <tr>
                      <td>Sedan Transportation Price	</td>
                      <td>Rs. 7,000 - 10000	</td>
                      <td>Rs. 10000 - 15000	</td>
                      <td>Rs. 13000 - 18000	</td>
                      <th>Rs. 15000 - 20000	</th>
                      <th>Rs. 18000 - 24000	</th>
                      <th>Rs. 21000 - 27000</th>

                    </tr>
                    <tr>
                      <td>SUV Car Transportation Price	</td>
                      <td >Rs. 13000 - 15000	</td>
                      <td>Rs. 15000 - 19000		</td>
                      <td>Rs. 18000 - 22000	</td>
                      <th>Rs. 21000 - 24000	</th>
                      <th>Rs. 23000 - 27000	</th>
                      <th>Rs. 25000 - 30000</th>

                    </tr>




                    <tr>
                      <td>Luxury Car Transportation Price	</td>
                      <td>Rs. 17000 - 21000	</td>
                      <td>Rs. 20000 - 25000	</td>
                      <td>Rs. 23000 - 27000		</td>
                      <th>Rs. 26000 - 31000	</th>
                      <th>Rs. 29000 - 35000	</th>
                      <th>Rs. 31000 - 40000</th>


                    </tr>





                  </tbody>
                </Table>

              </div>

            </div>

            <div>


            </div>






            <div>

            </div>




          </Slider>
        </div>
        <br />
        <br />


      </div>

      <br />




      <div className="album py-1">
        <div className="container">
          <center><h2><b>Car Shifting Services</b></h2></center>
          <div className="row">
            <div className="col-md-7 mt-2">

              <div className="card-body">

                <p className="card-text justify">Hassle-Free Car Shifting Services with AT India Packers Movers</p>
                <p className='justify'>Relocating your car from one city to another? Trust AT India Packers Movers, a name synonymous with safety, reliability, and timely delivery. We specialize in car transportation services across India, offering seamless door-to-door delivery with full protection for your vehicle.</p>
                <p><b>Professional Handling</b> Our expert team ensures your car is handled with utmost care using high-quality loading equipment and advanced vehicle carriers.</p>
                <p> <b>Enclosed & Open Car Carriers</b> We offer both open and closed car carriers based on your needs and budget, ensuring your car is delivered in its original condition.</p>
                <p> <b>Full Transit Insurance</b> We provide transit insurance for added peace of mind, protecting your vehicle from any unforeseen damage during transit</p>

                <p><b>Door-to-Door Pickup & Delivery</b> No need to drop your car at any terminal—our team will pick up and deliver your car right at your doorstep.</p>
                <p><b>Timely and Transparent Process</b> We value your time. From pickup to delivery, we ensure timely updates and zero hidden charges.</p>
              </div>
            </div>

            <div className="col-md-5 mt-2">
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube.com/embed/egOiCdxasjg"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>

              {/* <img src={carmove} className="d-block w-100" alt="carmove"/> */}

            </div>
          </div>
        </div>
      </div>


      <ShiftingProcess />


      <Callback />


    </div>
  )
}

export default CarRelocation